import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

 import { Recruiter } from '../models/recruiter.model';
import { UserLoginService, LoggedInCallback } from "../services/cognito/cognito.service";
import { CognitoTokensService } from '../services/cognito/cognito-tokens.service';

@Injectable()
export class RecruiterAuthenticationService implements LoggedInCallback {
  private users = [ ];
  authenticatedUser;
  recruiterloggedIn = false;
 
  constructor(private router: Router, 
              private userLoginService: UserLoginService,
              private cognitoTokenService: CognitoTokensService){    
  }
 
  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("username");
    localStorage.removeItem("talentPageIndex");
    localStorage.clear();
    this.router.navigate(['pages/login']);
  }
 
  loginUser(user){    
    this.authenticatedUser = this.users.find(u => u.email === user.email);   
    if (this.authenticatedUser && this.authenticatedUser.password === user.password){ 
      localStorage.setItem("recruiter", JSON.stringify(this.authenticatedUser));      
      localStorage.setItem("recruitername", this.authenticatedUser.firstname); 
      if(this.authenticatedUser.accounttype == 'recruiter'){  
        this.recruiterloggedIn = true;
        localStorage.setItem("recruiterloggedInflag",  '1');   
        this.router.navigate(['recruiter/dashboard']);}
      else{
       this.recruiterloggedIn = false;
      }
      return true;
    }   
    return false; 
  }
 
   checkCredentials() {
    if (localStorage.getItem("user") === null){
        this.router.navigate(['pages/login']);
    }
  } 
    isAuthenticated(){
    if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "recruiter"){
      this.recruiterloggedIn = this.cognitoTokenService.checkTokenExpiry();
    }else{
      this.recruiterloggedIn = false;
    }
    const promise = new Promise(
      (resolve, reject) =>{
        setTimeout(() => {          
          resolve(this.recruiterloggedIn)
        } ,800);
      }
      );   
    return promise;
  }
  isLoggedIn(message: string, isLoggedIn: boolean) {
      if (isLoggedIn) {
        this.userLoginService.logout();       
      }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/recruiter-authentication.service.ts